import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../auth";
import firebase from "../../firebase";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import ThumbUpAltOutlinedIcon from "@material-ui/icons/ThumbUpAltOutlined";
import Badge from "@material-ui/core/Badge";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  likeIcon: {
    color: theme.palette.text.secondary,
    transition: theme.transitions.create(["transform", "color"], {
      duration: theme.transitions.duration.standard,
      delay: 150,
    }),
    "&:hover": {
      transform: "scale(1.2, 1.2)",
      color: theme.palette.primary.main,
    },
  },
  likeIcon_Active: {
    color: theme.palette.primary.main,
    transition: theme.transitions.create(["transform", "color"], {
      duration: theme.transitions.duration.standard,
      delay: 150,
    }),
    "&:hover": {
      transform: "scale(1.2, 1.2)",
      color: theme.palette.text.secondary,
    },
  },
}));

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: 12,
    top: 35,
    padding: "0 4px",
  },
}))(Badge);

const ForumLikeButton = (props) => {
  const classes = useStyles();
  const handleVotes = firebase.functions().httpsCallable("handleVotes");
  const { currentUser } = useContext(AuthContext);
  const [voters, setVoters] = React.useState({});
  const [votes, setVotes] = React.useState(0);

  useEffect(() => {
    setVotes(props.votes);
  }, [props.votes]);

  useEffect(() => {
    setVoters(props.voters);
  }, [props.voters]);

  const updateVoters = (newVoters) => {
    setVoters(newVoters);
  };

  const handleLike = async (id) => {
    try {
      let clonedVotes = votes;
      const clonedVoters = { ...voters };
      if (clonedVoters[currentUser.uid] === true) {
        clonedVoters[currentUser.uid] = false;
        updateVoters(clonedVoters);
        setVotes((votes) => votes - 1);
      } else if (clonedVoters[currentUser.uid] === false) {
        clonedVoters[currentUser.uid] = true;
        updateVoters(clonedVoters);
        setVotes((votes) => votes + 1);
      } else {
        clonedVoters[currentUser.uid] = true;
        updateVoters(clonedVoters);
        setVotes((votes) => votes + 1);
      }

      handleVotes({
        id: id,
        fromPost: props.fromPost,
        urlParam: props.urlParam,
      });
    } catch (error) {
      //console.log(error);
    }
  };

  let likeButton = null;
  likeButton = (
    <Button
      startIcon={<ThumbUpAltOutlinedIcon />}
      disableElevation
      variant="text"
      color="primary"
      disabled={currentUser ? false : true}
      onClick={() => handleLike(props.id)}
      className={
        voters[currentUser ? currentUser.uid : null]
          ? classes.likeIcon_Active
          : classes.likeIcon
      }
    >
      {votes > 0 ? votes : ""}
    </Button>
  );
  /*
  //Original
  if (props.fromPost) {
    likeButton = (
      <IconButton
        onClick={() => handleLike(props.id)}
        aria-label="thumbup"
        disabled={currentUser ? false : true}
      >
        <StyledBadge badgeContent={votes > 0 ? votes : ""}>
          {
            <ThumbUpAltOutlinedIcon
              className={
                voters[currentUser ? currentUser.uid : null] && currentUser
                  ? classes.likeIcon_Active
                  : classes.likeIcon
              }
            />
          }
        </StyledBadge>
      </IconButton>
    );
  } else {
    likeButton = (
      <Button
        startIcon={<ThumbUpAltOutlinedIcon />}
        disableElevation
        variant="text"
        color="primary"
        disabled={currentUser ? false : true}
        onClick={() => handleLike(props.id)}
        className={
          voters[currentUser ? currentUser.uid : null]
            ? classes.likeIcon_Active
            : classes.likeIcon
        }
      >
        {votes > 0 ? votes : ""}
      </Button>
    );
  }
  */

  return (
    <span key={props.id}>
      <Tooltip
        title="Upvote"
        enterDelay={300}
        leaveDelay={200}
        enterNextDelay={300}
      >
        <span>{likeButton}</span>
      </Tooltip>
    </span>
  );
};

export default ForumLikeButton;
